var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"msg-pop-fade"}},[(_vm.show)?_c('div',{staticClass:"msg-pop"},[_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":_vm.onClose}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.modelMsg)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }